import { render } from "./Hero.vue?vue&type=template&id=39126482"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"

import "./Hero.vue?vue&type=style&index=0&id=39126482&lang=scss"

import exportComponent from "/codebuild/output/src2582523138/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__